import React, { useState, useEffect } from 'react';
import {
  Show,
  SimpleShowLayout,
  useShowController,
} from 'react-admin';
import VideoModal from './VideoModal';
import MediaButton from './MediaButton';
import { 
  Card, 
} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import ArticleIcon from '@mui/icons-material/Article';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideocamIcon from '@mui/icons-material/Videocam';
import BackButton from './BackButton';
import { supabaseClient } from './supabase';

const DisciplineShow = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [disciplineWithURL, setDisciplineWithURL] = useState(null);
  const [disciplineWithURLLoading, setDisciplineWithURLLoading] = useState(false);
  const [disciplineWithURLError, setDisciplineWithURLError] = useState(null);  

  const handleClick = (url) => {
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const getType = (type) => {
    const types = {
      D: <ArticleIcon />,
      P: <PictureAsPdfIcon />,
      V: <VideocamIcon />,
      T: <ImageIcon />,
    };
    return types[type];
  };

  const {
    record: discipline,
    isLoading: disciplineLoading,
    error: disciplineError,
  } = useShowController();
 
  console.log(`discipline: ${JSON.stringify(discipline)}`);

  async function fetchDisciplineWithUrl(discipline) {
    const mustDownload = discipline.type !== 'V' ? { download: discipline.file } : {};
    const { data: media, error: mediaError } = await supabaseClient.storage
      .from('media')
      .createSignedUrl(`${discipline.file}`, 
        3600, 
        mustDownload
      );        
    if (mediaError) throw new Error('>>>>>>>> Throwing internal error in supabaseClient.storage...', mediaError.message);
    console.log(`media that is returned: ${JSON.stringify(media)}`);
    const path = media.signedUrl;
    return {
      ...discipline,
      url: path
    }
  };  

  useEffect(() => {
    if (discipline && discipline.file) {
      setDisciplineWithURLLoading(true);
      fetchDisciplineWithUrl(discipline)
        .then((updatedDiscipline) => {
          setDisciplineWithURL(updatedDiscipline);
          setDisciplineWithURLLoading(false);        
        })
        .catch((error) => {
          console.log('Failed to fetch updated discipline:', error);
          setDisciplineWithURLError(error);
          setDisciplineWithURLLoading(false);
        });
    }
  }, [discipline]);

  if (disciplineLoading || disciplineWithURLLoading) return <div>Loading....</div>;
  if (disciplineError || disciplineWithURLError) return <div>Error: {disciplineWithURLError?.message}</div>;
  
  console.log('disciplineWithURL:', disciplineWithURL);

  return disciplineWithURL && (
    <Show {...props} title="Discipline Record" actions={false}>
      <SimpleShowLayout>
        <h2>{disciplineWithURL.title}</h2>
        {disciplineWithURL.description && <p dangerouslySetInnerHTML={{ __html: disciplineWithURL.description}} />}
        {['P', 'D', 'V', 'T'].includes(disciplineWithURL.type) && (
          <Card sx={{ display: 'flex', width: '100%', padding: '2rem' }}>
            <span style={{ paddingRight: '1em', alignSelf: 'center' }}>
              {getType(`${disciplineWithURL.type}`)}
            </span>
            <MediaButton 
              mediaType={disciplineWithURL.type}
              mediaPath={disciplineWithURL.url}
              mediaTitle={disciplineWithURL.title}
              handleClick={handleClick} 
            />
          </Card>
        )}
        <VideoModal
          isOpen={isModalOpen}
          handleClose={handleCloseModal}
          videoUrl={videoUrl}
        />
        <BackButton />
      </SimpleShowLayout>
    </Show>
  );
};

export default DisciplineShow;
